import React, {useEffect, useState} from "react";
import TitleBlock from "commons-ui/core/TitleBlock";
import queryString from "query-string";
import {dataSourceV2} from "commons-ui/core/DataSource";
import {
    onAddFilterTemplate,
    onDeleteFilterTemplate,
    requestProductListTemplate
} from "ecommerce-commons-ui/core/ProductGallery";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import GitHub from "@material-ui/icons/GitHub";
import LinkedIn from "@material-ui/icons/LinkedIn";
import Loading from "commons-ui/core/Loading";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Link from "next/link";
import { useStore } from "../../context/state";
import "./style.styl";


export default function BlogCategoryContent(props) {
    const {category, noTitle, loadAll, showEmpty, renderAll} = props;
    const {isMobile, dispatch, blogPath} = useStore();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);


    const request = () => {
        dataSourceV2("wp-json/wp/v2/posts?_embed&categories=" + category.id, {url: blogPath})
            .then(v=> {
                const data = [];
                (v || []).forEach(item => {
                    if (item.sticky) {
                        data.unshift(item);
                    } else {
                        data.push(item);
                    }
                });
                setItems(data);
                setLoading(false);
            });
    };

    useEffect(() => {
        request();
        window.scrollTo(0, 0);
    }, []);


    if (loading) {
        return (
            <div>
                <Loading/>
            </div>
        );
    }

    if (items.length === 0 && showEmpty) {
        return (
            <div className="u-marginBottom30 u-flexCenter u-justifyContentCenter">
                <h2 className="u-textColorPrimary u-fontWeightBold u-fontSize30">Coming Soon</h2>
            </div>
        );
    }

    if (items.length === 0) {
        return null;
    }



    return (
        <section >
            {
                noTitle ?
                    null
                    :
                    <div className="u-marginBottom30 u-flexCenter u-justifyContentCenter">
                        <h2 className="u-textColorPrimary u-fontWeightBold u-fontSize30">{category.name}</h2>
                    </div>
            }
            <div className="u-flexCenter u-justifyContentCenter u-hide">
                <div className="title u-marginBottom30">
                    <TitleBlock {...props}
                                isAlignCenter
                                title={<span className="u-fontSize28 u-textColorSecondary u-fontWeightBold">{category.name}</span>}/>
                </div>
            </div>
            <div className="u-flex u-flexWrap u-paddingBottom100">
                {
                    items.length === 0 ?
                        <span className="u-sizeFullWidth u-fontWeightBold u-fontSize30 u-marginVertical40 u-flexCenter u-justifyContentCenter">Coming Soon</span>
                        :
                        null
                }
                {
                    items.map((item, i) => {
                        let type = i === 0 ? "full" : (i > 2 ? "small" : (i % 2 === 0 ? "right" : "left"));
                        if (isMobile) {
                            type = "mobile";
                        }
                        if (i > (isMobile ? 2 : 4) && !renderAll) {
                            return null;
                        }
                        return (
                            <div key={i} className={"article-container " + type} style={{marginRight: type === "small" && i % 2 !== 0 ? 20 : undefined , marginLeft: type === "small" && i % 2 === 0 ? 20 : undefined }}>
                                <Article
                                            item={item}
                                            type={type}
                                            dispatch={dispatch}
                                />
                            </div>
                        );
                    })
                }
                {
                    items.length > (isMobile ? 3 : 5) && !renderAll ?
                        <Link href={"/blog/category/" + category.slug}>
                            <a className="more-button">
                                <div>
                                    <span className="u-flexCenter">Read More <ArrowDropDownIcon fontSize="large" className="u-marginLeft10"/></span>
                                </div>
                            </a>
                        </Link>
                        :
                        null
                }
            </div>
        </section>
    );
}


function Article(props) {
    const {item, type, mediaPath, dispatch} = props;

    const image = (((item._embedded || {})["wp:featuredmedia"] || [])[0] || {}).source_url || "";



    return (
        <div className={"article u-sizeFullHeight u-flexCenter u-alignItemsCenter u-justifyContentStart u-xs-flexColumn " + type}>
            <div className="image">
                <Link href={"/blog/" + item.slug}>
                    <a>
                        <Avatar className="avatar u-xs-marginBottom20" variant="square" src={image}/>
                    </a>
                </Link>
            </div>

                <div className="body">
                    <TitleBlock {...props}
                                title={
                                    <Link href={"/blog/" + item.slug}>
                                        <a>
                                            {item.title.rendered}
                                        </a>
                                    </Link>

                                }
                                description={item.excerpt.rendered}
                    />

                <div className="u-flexCenter u-justifyContentEnd u-xs-justifyCenter u-xs-hide">
                    <Link href={"/blog/" + item.slug}>
                        <a>
                            <Button aria-label="Read More about this Blog" className="" color="secondary" className="button-secondary" type="outlined" size="large">
                                Read More
                            </Button>
                        </a>
                    </Link>

                </div>
            </div>
        </div>
    );
}
